// --------------------------
// IMPORTS
// --------------------------
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Space, Button, Form, Input, DatePicker } from "antd";
import dayjs from "dayjs";

// --------------------------
// MAIN COMPONENT
// --------------------------
export const CurrencyRateHistoryList = ({ role, name,disabledDate }) => {
  const isSuperAdmin = role === process.env.REACT_APP_SROLE;

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) =>  {
        // Add default row for non-superadmin
        if (!isSuperAdmin && fields.length === 0) {
          add({ rate: "", effectiveDateTime: null });
        }

        return (
        <div className="currencyRepeat">
          {fields.map(({ key, name, ...restField }) => (
            <Space className="currencyRepeatWrap" key={key} align="baseline">
              <Form.Item
                {...restField}
                name={[name, "rate"]}
                label="Rate"
                rules={[
                  { required: true, message: "Please input currency rate!" },
                  {
                    pattern: /^\d+(\.\d{1,2})?$/,
                    message: "Enter a currency rate (up to 2 decimal places)",
                  },
                ]}
              >
                <Input placeholder="Enter the currency rate" />
              </Form.Item>

              <Form.Item
                {...restField}
                name={[name, "effectiveDateTime"]}
                label="Effective Date & Time"
                rules={[
                  { required: true, message: "Please select date & time" },
                ]}
                getValueProps={(value) => ({
                  value: value ? dayjs(value) : null,
                })}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  disabledDate={disabledDate}
                  getPopupContainer={(trigger) => trigger.parentNode}
                />
              </Form.Item>
              {isSuperAdmin && (
              <MinusCircleOutlined
                onClick={() => remove(name)}
                style={{ color: "red", marginBottom: "13px" }}
              />)}
            </Space>
          ))}

          {isSuperAdmin && (

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add({ rate: "", effectiveDateTime: dayjs() })}
              block
              icon={<PlusOutlined />}
            >
              Add Rate History
            </Button>
          </Form.Item>)}
        </div>
        
      )}}
    </Form.List>
  );
};
